import { jsx } from 'react/jsx-runtime';
import React, { useMemo } from 'react';
import { sanitizeNodeProps } from '@contentful/experiences-core';
import { useMediaQuery } from '../../hooks/useMediaQuery.js';
import { useInjectStylesheet } from '../../hooks/useInjectStylesheet.js';
import classNames from 'classnames';

/**
 * This component is used to render a placeholder Image component in the preview
 * when the image is unbound. It applies the Image size styles to a wrapping div.
 */
const PreviewUnboundImage = ({ breakpoints, node, nodeProps, component, patternRootNodeIdsChain, }) => {
    const { wrapperStyle, imageStyle } = useMemo(() => {
        const imageStyle = {};
        const wrapperStyle = {};
        if (nodeProps.cfImageOptions && typeof nodeProps.cfImageOptions === 'object') {
            for (const [breakpointId, styles] of Object.entries(nodeProps.cfImageOptions)) {
                imageStyle[breakpointId] = {
                    cfImageOptions: {
                        ...styles,
                        height: '100%',
                        width: '100%',
                    },
                };
                wrapperStyle[breakpointId] = {
                    cfHeight: styles.height,
                    cfWidth: styles.width,
                };
            }
        }
        return { imageStyle, wrapperStyle };
    }, [nodeProps.cfImageOptions]);
    const wrapperMedia = useMediaQuery({
        designPropertiesByBreakpoint: wrapperStyle,
        node,
        breakpoints,
        patternRootNodeIdsChain,
    });
    const imageMedia = useMediaQuery({
        designPropertiesByBreakpoint: imageStyle,
        node,
        breakpoints,
        patternRootNodeIdsChain,
    });
    useInjectStylesheet(wrapperMedia.css);
    useInjectStylesheet(imageMedia.css);
    return (jsx("div", { className: classNames('cf-preview-unbound-image', wrapperMedia.className), children: React.createElement(component, {
            ...sanitizeNodeProps(nodeProps),
            className: classNames(nodeProps.className, imageMedia.className),
        }) }));
};

export { PreviewUnboundImage as default };
//# sourceMappingURL=PreviewUnboundImage.js.map
